import { getReadableTextColor, hexColorForString } from '@/shared/utils/color'

export function log(...args: unknown[]) {
  window.fathomLogger?.log(...args)
}

export function logWithBadge(label: string, ...args: unknown[]) {
  const badgeColor = hexColorForString(label)
  const textColor = getReadableTextColor(badgeColor)
  log(
    `%c${label}`,
    `background: ${badgeColor}; color: ${textColor}; padding: .3em 1ch; border-radius: .3em`,
    window.location.href,
    ...args,
  )
}
